<template>
    <div class="configurator-select-buttons mb-4" v-bind:id="groupId">
        <accordion :show="true">
            <div slot="header">{{ title }}</div>

            <div class="toggle-switch-container mt-3 mb-3">
                <div v-if="group === 'Ausstattung' && showCompare" class="d-none d-md-block mb-2 text-md-right">
                    <a href="" class="text-md-right btn btn-secondary" data-toggle="modal" data-target="#compareModal">
                        <i class="fal fa-list mr-1"></i> {{ $t('personalize.compareButton') }}</a>
                </div>

                <div v-else-if="group === 'Rahmengröße'" class="mb-2 text-right">
                    <button
                        class="btn btn-secondary"
                        id="my-custom-oz-button"
                        data-oz-widget="sizing"
                        data-oz-embed="custom"
                        v-bind:data-oz-code=bikeCode
                        v-bind:data-oz-name=bikeName
                        v-bind:data-oz-image=bikeImage
                        data-oz-fullscreen="true"
                        v-bind:data-oz-language=this.$parent.langSelected.toLowerCase()
                        data-oz-primary="#ec7205"
                        data-oz-cta="#ec7205"
                        data-oz-text="#131313"
                        data-oz-highlight="#ec7205"
                        data-oz-buttonTextColor="#ffffff"
                    >
                        {{ $t('personalize.selectSize') }} <i class="fal fa-question" aria-hidden="true"></i>
                    </button>
                </div>

                <toggle-switch :options="options" :group='group' :loading="loading" @change="buttonSelected" />
            </div>
        </accordion>

        <div v-if="group === 'Ausstattung'" class="modal fade" id="compareModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('personalize.compareModalTitle') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i> {{ $t('personalize.compareModalCloseButton') }}
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="option in options" class="row">
                            <div v-for="data in option.labels" v-if="data.InfoText" class="col-md-6 col-lg-4">
                                <div class="title">{{ data.Description }}</div>
                                <div v-html="data.InfoText">
                                    {{ data.InfoText }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import ToggleSwitch from '@/components/ToggleSwitch.vue'

    export default {
        name: 'SelectButtons',
        components: {
          ToggleSwitch
        },
        props: {
            bikeName: String,
            bikeCode: String,
            bikeImage: String,
            title: String,
            group: String,
            characteristic: Array
        },
        data() {
          return {
              options: {},
              loading: true,
              requests: {},
              equipment: {},
              showCompare: false
          }
        },
        computed: {
            groupId() {
                return this.group.replace(/ /gi, "_")
            }
        },
        methods: {
            async getGroupData() {
                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', this.$parent.$parent.ConfigurationID);
                params.append('CustomerID', this.$parent.$parent.customerID);

                let values = [];
                let selected = '';
                let app = this;
                let parent = app.$parent;
                let compare = 0;

                app.getGroupDataPost(app,parent,params,values,selected,compare);
            },
            getGroupDataPost(app,parent,params,values,selected,compare) {
                this.$http.post(this.$apiurl + '/api/GetGroupData/' + this.group, params)
                    .then(response => {
                        $.each(response.data['ReturnData'], function(indexData, valueData) {
                            $.each(valueData.Value, function(indexSelect, valueSelect) {
                                values = valueSelect;
                                app.equipment = valueSelect;

                                $.each(valueSelect, function (indexSelected, valueSelected) {
                                    if(valueSelected['Selected'] === true) selected = valueSelected['Description'];
                                    if(valueSelected['InfoText']) compare++;
                                })
                            });

                            app.options = {
                                items: {
                                    preSelected: selected,
                                    labels: values
                                }
                            }
                        });

                        if(compare >= 2) app.showCompare = true;

                        parent.stateCounter = parent.stateCounter + 1;
                        if(parent.stateCounter === 1) {
                            parent.renderCircuitType = true;
                        }
                        if(parent.stateCounter === 2) {
                            parent.renderEquipment = true;
                        }
                        if(parent.stateCounter >= 3)
                        {
                            parent.renderFrameColor = true;
                            app.$parent.$parent.loading = false;

                        }
                    })
                    .catch(error => {
                        app.getGroupDataPost(app,parent,params,values,selected,compare)
                    })
                    .finally(() => parent.loading = false);
            },
            buttonSelected (data) {
                let app = this;
                let parent = app.$parent;

                this.$parent.popupError = false;

                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', this.$parent.$parent.ConfigurationID);
                params.append('Characteristic', this.characteristic[0]);
                params.append('Value', data.value);
                params.append('CustomerID', this.$parent.$parent.customerID);

                app.$parent.$parent.loading = true;

                app.buttonSelectedPost(app,parent,params);
            },
            buttonSelectedPost(app,parent,params) {
                this.$http.post(this.$apiurl + '/api/SetValue', params)
                    .then(response => {
                        let parent = this.$parent;

                        let values = [];
                        let selected = '';

                        $.each(response.data['ReturnData'], function(indexData, valueData) {
                            $.each(valueData.Value, function(indexSelect, valueSelect) {
                                $.each(valueSelect, function(indexItem, valueItem) {
                                    values = valueSelect;

                                    $.each(valueSelect, function (indexSelected, valueSelected) {
                                        if(valueSelected['Selected'] === true)
                                        {
                                            selected = valueSelected['Name'];
                                        }
                                    })
                                });
                            });

                            let ref = app.$parent.$refs['selectButtons_' + valueData['Category']];

                            ref[0].options = {
                                items: {
                                    preSelected: selected,
                                    labels: values
                                }
                            }
                        });

                        if(response.data['TransferData'])
                        {
                            if(response.data['TransferData']['doRefreshGroups'])
                            {
                                parent.getGroups(parent.$parent.ConfigurationID);

                                parent.renderFrameColor = false;
                                parent.renderMoreOptions = false;

                                this.$nextTick(() => {
                                    parent.renderFrameColor = true;
                                    parent.renderMoreOptions = true;
                                });
                            } else {
                                app.$parent.$parent.loading = false;
                            }

                            if(response.data['TransferData']['ConfigurationID']) {
                                parent.$parent.ConfigurationID = response.data['TransferData']['ConfigurationID'];
                            }

                        } else {
                            app.$parent.$parent.loading = false;
                        }

                        parent.$parent.step = 1;
                    })
                    .catch(error => {
                        app.buttonSelectedPost(app,parent,params);
                    })
            }
        },
        async created() {
            await this.getGroupData();
            oz.destroy();
            oz.initialize();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .toggle-switch-container {
        min-height: 90px;
    }
    .toggle-switch-container >>> .toggle-switch {
        display: flex;
        flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        align-items: flex-start;
        -ms-flex-align: start;

        height: auto !important;
        width: 100% !important;
    }
    .toggle-switch-container >>> .toggle-switch li {
        width: 100% !important;
        margin-bottom: 2%;
    }
    .toggle-switch-container >>> .toggle-switch li:nth-child(2),
    .toggle-switch-container >>> .toggle-switch li:nth-child(4),
    .toggle-switch-container >>> .toggle-switch li:nth-child(6),
    .toggle-switch-container >>> .toggle-switch li:nth-child(8),
    .toggle-switch-container >>> .toggle-switch li:nth-child(10)
    {
        margin-right: 0;
    }
    .toggle-switch-container >>> .toggle-switch li:last-child {
        margin-right: 0;
    }
    @media (min-width: 768px) {
        .toggle-switch-container >>> .toggle-switch li {
            width: 49% !important;
            margin-right: 2%;
        }
    }
    @media (min-width: 992px) {
        .toggle-switch-container >>> .toggle-switch li {
            width: 32% !important;
            margin-right: 2%;
        }
        .toggle-switch-container >>> .toggle-switch li:nth-child(2),
        .toggle-switch-container >>> .toggle-switch li:nth-child(4),
        .toggle-switch-container >>> .toggle-switch li:nth-child(6),
        .toggle-switch-container >>> .toggle-switch li:nth-child(8),
        .toggle-switch-container >>> .toggle-switch li:nth-child(10) {
            margin-right: 2%;
        }
        .toggle-switch-container >>> .toggle-switch li:nth-child(3), .toggle-switch-container >>> .toggle-switch li:nth-child(6), .toggle-switch-container >>> .toggle-switch li:nth-child(9) {
            margin-right: 0;
        }
    }

    .toggle-switch-container >>> .toggle-switch li label.disabled {
        opacity: 0.5;
    }
    .toggle-switch-container >>> .toggle-switch li label.disabled.selected:hover {
        opacity: 0.5;
        border: 2px solid #ec7205 !important;
    }
    .toggle-switch-container >>> .toggle-switch li label.disabled:hover {
        opacity: 0.5;
        border: 2px solid #afb0af !important;
    }
    .toggle-switch-container >>> .toggle-switch li label {
        border: 2px solid #afb0af;
        transition: none !important;
        position: relative;
    }
    .toggle-switch-container >>> .toggle-switch li:last-child label {
        border: 2px solid #afb0af;
    }
    .toggle-switch-container >>> .toggle-switch li label:hover {
        border: 2px solid #ec7205 !important;
        transition: none !important;
    }
    .toggle-switch-container >>> .toggle-switch li label.selected {
        font-weight: normal !important;
        border: 2px solid #ec7205 !important;
    }

    #compareModal {
        padding: 0 !important;
    }

    #compareModal .modal-dialog {
        max-width: none;
        margin: 0;
        height: 100%;
    }
    #compareModal .modal-dialog .modal-content {
        height: 100%;
        border-radius: 0;
        border: 0;
    }
    #compareModal .modal-dialog .modal-content .modal-header .modal-title {
        font-size: 24px;
        font-weight: bold;
        line-height: 1.2;
        letter-spacing: 0.38px;
        text-transform: uppercase;
    }
    #compareModal .modal-dialog .modal-content .modal-header .close {
        font-size: 10px;
        line-height: 1.2;
        letter-spacing: 0.42px;
        text-align: center;
        color: #131313;
        opacity: 1;
    }
    #compareModal .modal-dialog .modal-content .modal-header .close:hover {
        color: #ec7205;
    }
    #compareModal .modal-dialog .modal-content .modal-header .close i {
        font-size: 42px;
        display: block;
    }
    #compareModal .modal-dialog .modal-content .modal-body {
        line-height: 2;
        font-size: 15px;
        overflow: auto;
    }
    #compareModal .modal-dialog .modal-content .modal-body .title {
        margin-bottom: 0;
        font-size: 18px;
    }
    #compareModal .modal-dialog .modal-content .modal-body >>> .description  {
        color: #131313;
        line-height: 1.4;
        font-weight: bold;
        margin-bottom: 20px;
    }
    #compareModal .modal-dialog .modal-content .modal-body >>> strong {
        font-weight: bold;
    }

    #compareModal .modal-dialog >>> ul {
        padding-inline-start: 0px;
        list-style: none;
    }
    #compareModal .modal-dialog >>> ul li {
        padding: 5px;
    }
    #compareModal .modal-dialog >>> ul li:nth-child(odd) {
        background-color: #eeeeee;
    }

    @media (min-width: 768px) {
        #compareModal .modal-dialog {
            max-width: 95%;
            margin: 100px auto;
            height: 80%;
        }
        #compareModal .modal-dialog >>> .row {
            flex-wrap: nowrap;
        }
    }

</style>